if (process.env.NODE_ENV === 'development') {
  require('@webcomponents/shadydom');
}